/**
 * @file util files 后续迁移到cjh-fe-utils
 * @author zhuqijia
 */

import Const from '@/pages/dache-activity/constant/Constant';
// 转化px刻度为vw
export const px2vw = (val, screenW = 750) => {
    return `${Math.floor((val * 100000) / screenW) / 1000}vw`;
};

// 转化通用样式
export const transStyle = (data = {}) => {
    const style = {};
    Object.keys(data).forEach(key => {
        if (key === 'img_url') {
            style.backgroundImage = `url(${data.img_url})`;
        }
        if (Const.styleLabel.number.includes(key)) {
            style[key] = px2vw(data[key]);
            if (key === 'height') {
                style.backgroundSize = `100% ${style.height}`;
            }
        }
        else if (Const.styleLabel.image.includes(key)) {
            style[key] = `url(${data[key]})`;
        }
        else {
            style[key] = data[key];
        }
    });
    return style;
};

// 遍历获取对象及子对象中指定key的value值
export const getObjectValuesByKey = (obj = {}, key) => {
    let values = [];
    if (obj.constructor === Object) {
        Object.keys(obj).forEach(v => {
            if (obj[v] && v === key && obj[v].constructor === String) {
                values.push(obj[v]);
            }
            else if (obj[v] && obj[v].constructor === Object) {
                values = values.concat(getObjectValuesByKey(obj[v], key));
            }
        });
    }
    // return values.filter((v, k) => values.indexOf(v) === k);
    return values;
};

